module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-f6072fe4c7bf48bc182e4a19d7fb729b.jpg";